import { Action, CustomTagType, ErrorCodes, OperationType, Position, WarningType, WindowType } from "puzzle";
import ExportViewer from "../components/Drawer/Tabs/Files/ExportViewer";
import AddCommentsDialog from "../components/Drawer/Tabs/Files/Comments/AddCommentsDialog/AddCommentsDialog";

export const getFilesGridData: Action = [{
  moduleName: 'Files',
  name: 'getFilesTabUrl',
  mappingName: 'filesTabUrl',
  type: OperationType.addOperationData
}, {
  data: {
    template: {
      bind: {
        url: '{filesTabUrl}',
        params: '{params}'
      }
    },
  },
  mappingName: 'gridData',
  type: OperationType.request
}, {
  moduleName: 'Files',
  name: 'setGridConfig',
  args: ['gridData'],
  type: OperationType.addOperationData
}, {
  moduleName: 'Files',
  name: 'setGridData',
  args: ['gridData'],
  type: OperationType.addOperationData
}, {
  condition: '{skipMassConfiguration}', //It is used to check whether the endpoint should be called or not. If set to true, it means that in the same flow, but for the next pass, it needs to be reset.
  conditionOperations: [{
    data: { skipMassConfiguration: false },
    type: OperationType.data
  }],
  elseOperations: [{
    name: 'getMassActionConfigurationBySubmission',
    type: OperationType.action
  }],
  type: OperationType.conditional
}, {
  moduleName: 'App',
  type: OperationType.unmaskModule
}];

export const prefilterFiles: Action = [{
  data: {
    template: {
      bind: {
        tab: '{filesFilter.tab}',
        filters: '{filesFilter.filters}'
      }
    }
  },
  persistent: ['filesFilter'],
  type: OperationType.addPersistentData
}, {
  moduleName: 'DrawerContent',
  name: 'handleSelect',
  args: ['tab', 'filters']
}, {
  name: 'getFilesGridFilterConfig',
  type: OperationType.action
}, {
  moduleName: "Files",
  name: "preFilterFromStatusTab",
  args: ['filters']
}, {
  type: OperationType.removePersistentData,
  persistent: ['filesFilter']
}];

export const filterFilesGrid: Action = [{
  persistent: ['filesGridFilter'],
  type: OperationType.addPersistentData
}, {
  data: {
    clear: false,
    forceRequest: true
  },
  type: OperationType.data
}, {
  moduleName: 'Files',
  name: 'resetGridData',
  args: ['clear', 'forceRequest']
}];

export const getFilesGridFilterConfig: Action = [{
  waitForModule: true,
  moduleName: 'Files',
  name: 'getSearchBarInfoUrl',
  mappingName: 'searchBarInfoUrl',
  type: OperationType.addOperationData
}, {
  data: {
    template: {
      endpointPrefix: 'SEARCH_INFO_',
      method: 'get',
      bind: {
        url: `_.replace({searchBarInfoUrl},'%getParam%', {selectedSubmissions[0].taskId} || {selectedSubmissions[0].submissionId}} )`
      }
    },
  },
  handleErrorStatuses: [ErrorCodes.FORBIDDEN, ErrorCodes.NOT_FOUND, ErrorCodes.BAD_REQUEST, ErrorCodes.INTERNAL_SERVER_ERROR],
  mappingName: 'filterData',
  type: OperationType.request
}, {
  data: {
    template: {
      bind: {
        responseData: '{filterData}',
      }
    }
  },
  name: 'handleRequestException',
  type: OperationType.action
}, {
  moduleName: 'Files',
  name: 'setTagFilterData',
  args: ['filterData']
}
];

export const getMassActionConfigurationBySubmission: Action = [{
  moduleName: 'Files',
  name: 'getMassActionRequestParams',
  mappingName: 'massActionParams',
  type: OperationType.addOperationData
}, {
  condition: '{massActionParams.requestUrl}',
  conditionOperations: [{
    data: {
      template: {
        method: 'post',
        bind: {
          url: '{massActionParams.requestUrl}',
          params: '{massActionParams.requestParams}'
        }
      }
    },
    handleErrorStatuses: [ErrorCodes.FORBIDDEN, ErrorCodes.NOT_FOUND, ErrorCodes.BAD_REQUEST, ErrorCodes.INTERNAL_SERVER_ERROR],
    mappingName: 'massActionConfiguration',
    type: OperationType.request
  }, {
    data: {
      template: {
        bind: {
          responseData: '{massActionConfiguration}',
        }
      }
    },
    name: 'handleRequestException',
    type: OperationType.action
  }, {
    moduleName: 'Files',
    name: 'setMassActionConfiguration',
    args: ['massActionConfiguration']
  }],
  type: OperationType.conditional
}];

export const getFilesGridSummaryInfo: Action = [{
  moduleName: 'Files',
  name: 'getSummaryInfoParams',
  mappingName: 'summaryInfoParams',
  type: OperationType.addOperationData
}, {
  data: {
    template: {
      method: 'post',
      bind: {
        url: '{summaryInfoParams.summaryInfoUrl}',
        params: '{summaryInfoParams.summaryInfoRequestParams}'
      }
    }
  },
  mappingName: 'summaryInfo',
  type: OperationType.request
}, {
  args: ['summaryInfo'],
  moduleName: 'Files',
  name: 'setCancelledFilesNumber'
}];

export const getFilesDataAndFilters: Action = [{
  moduleName: 'App',
  type: OperationType.maskModule
}, {
  condition: '{initializeUserData.userProfile.userInfo.userType} !== "VENDOR"',
  conditionOperations: [{
    name: 'getProjectPolicies',
    type: OperationType.action
  }],
  type: OperationType.conditional
}, {
  condition: '{clearFilter}',
  conditionOperations: [{
    moduleName: 'Files',
    name: 'resetFilters',
  }],
  type: OperationType.conditional
}, {
  condition: '{getFilterConfig}',
  conditionOperations: [{
    name: 'getFilesGridFilterConfig',
    type: OperationType.action
  }],
  type: OperationType.conditional
}, {
  condition: '!{clearFilter}',
  conditionOperations: [{
    name: 'getFilesGridSummaryInfo',
    type: OperationType.action
  }],
  type: OperationType.conditional
}, {
  data: {
    pageNumber: 0
  },
  moduleName: 'Files',
  name: 'requestData',
  args: ['pageNumber']
}];

export const getOnlineEditorAddress: Action = [{
  persistent: ['onlineEditorParams', 'openFromFileClick'],
  type: OperationType.addPersistentData
}, {
  data: {
    template: {
      method: 'post',
      bind: {
        url: '{urlsEndpoint}',
        params: '{onlineEditorParams}'
      }
    }
  },
  handleErrorStatuses: [ErrorCodes.FORBIDDEN, ErrorCodes.NOT_FOUND, ErrorCodes.BAD_REQUEST, ErrorCodes.INTERNAL_SERVER_ERROR],
  mappingName: 'onlineEditorUrl',
  type: OperationType.request
}, {
  condition: `!_.get({onlineEditorUrl}, "response.data.errors")}`,
  conditionOperations: [{
    condition: '{onlineEditorUrl[0].editorUrl.indexOf("exportViewer") > -1}',
    conditionOperations: [{
      children: [{
        render: ExportViewer,
        propArgs: ['onlineEditorUrl']
      }],
      items: [],
      className: 'xl',
      title: 'exportViewer.title',
      type: OperationType.dialog
    }],
    elseOperations: [{
      condition: '{onlineEditorUrl[0].editorUrl}.includes("payloadId") || {onlineEditorUrl[0].editorUrl}.includes("editorSessionId")',
      conditionOperations: [{
        moduleName: 'Files',
        name: 'prepareEditorOpen',
        args: ['onlineEditorUrl', 'onlineEditorParams'],
        type: OperationType.addOperationData
      }],
      elseOperations: [{
        data: {
          addTheme: false
        },
        moduleName: 'ActionExecutor',
        name: 'openInPreviewMode',
        args: ['onlineEditorUrl', 'addTheme']
      }],
      type: OperationType.conditional
    }],
    type: OperationType.conditional
  }, {
    persistent: ['onlineEditorParams', 'openFromFileClick'],
    type: OperationType.removePersistentData
  }],
  elseOperations: [{
    name: 'filesTabWarningTemplate',
    type: OperationType.action
  }],
  type: OperationType.conditional
}];

export const tsoNotification: Action = [{
  moduleName: 'Files',
  name: 'getTSOUploadNotification',
  args: ['pingData'],
  mappingName: 'tsoNotification',
  type: OperationType.addOperationData
}, {
  moduleName: 'ToastNotifications',
  name: 'setNotification',
  args: ['tsoNotification']
}];

export const processEditorClose: Action = [{
  condition: '{pingData} && {pingData.processingFinished}',
  conditionOperations: [{
    condition: '{pingData.uploadReportsDto}',
    conditionOperations: [{
      actionType: {
        dispatcherId: 'mainDispatcher'
      },
      name: 'tsoNotification',
      type: OperationType.action
    }],
    type: OperationType.conditional
  }, {
    actionType: {
      dispatcherId: 'mainDispatcher'
    },
    name: 'refreshApp',
    type: OperationType.action
  }, {
    dispatcherIds: ['batchPingDispatcher'],
    type: OperationType.unlink
  }],
  elseOperations: [{
    condition: '!_.get({pingData}, "response.data.errors")}',
    conditionOperations: [{
      actionType: {
        dispatcherId: "batchPingDispatcher",
        delay: 1000
      },
      data: {
        template: {
          bind: {
            editorSessionId: '{pingParam.editorSessionId}'
          }
        }
      },
      name: 'pingBatchRequest',
      type: OperationType.stack
    }],
    type: OperationType.conditional
  }],
  type: OperationType.conditional
}];

export const pingBatchRequest: Action = [{
  data: {
    template: {
      method: 'get',
      bind: {
        url: "'/submissions/' + {selectedSubmissions[0].submissionId} +'/upload/report/' + {editorSessionId}"
      }
    }
  },
  handleErrorStatuses: [ErrorCodes.FORBIDDEN, ErrorCodes.NOT_FOUND, ErrorCodes.BAD_REQUEST, ErrorCodes.INTERNAL_SERVER_ERROR],
  mappingName: 'pingData',
  type: OperationType.request,
}, {
  data: {
    template: {
      bind: {
        responseData: '{pingData}',
      }
    }
  },
  name: 'handleRequestException',
  type: OperationType.action
}, {
  items: ['pingData'],
  type: OperationType.syncDispatchersDataItem
}, {
  name: 'processEditorClose',
  type: OperationType.action
}];

/**
 * Performs mainGrid refresh and files tab refresh on attached drawer
 */
export const refreshFilesGridToCurrentPosition: Action = [{
  name: 'refreshMainGridOnCurrentPosition',
  type: OperationType.action
}, {
  name: 'refreshFilesGrid',
  type: OperationType.action
}];

export const refreshFilesGrid: Action = [{
  moduleName: 'Files',
  name: 'getScrollPosition',
  mappingName: 'scrollPosition',
  type: OperationType.addOperationData
}, {
  data: {
    clear: false,
    forceRequest: false,
    getFilterConfig: null
  },
  moduleName: 'Files',
  args: ['clear', 'forceRequest', 'getFilterConfig', 'preserveSkip'],
  name: 'resetGridData',
}, {
  data: {
    preparePageNumber: 0
  },
  moduleName: 'Files',
  name: 'prepareRequestParams',
  mappingName: 'params',
  args: ['preparePageNumber'],
  type: OperationType.addOperationData
}, {
  name: 'getFilesGridData',
  type: OperationType.action
}, {
  name: 'getFilesGridSummaryInfo',
  type: OperationType.action
}, {
  moduleName: 'Files',
  args: ['scrollPosition'],
  name: 'scrollToLastPosition',
  // If Files tab is not active, next actions won't proceed
}];

export const sortChange: Action = [{
  moduleName: 'App',
  type: OperationType.maskModule
}, {
  data: {
    sort: true
  },
  type: OperationType.data
}, {
  moduleName: "Files",
  name: 'getPageNumber',
  mappingName: 'pageNumber',
  type: OperationType.addOperationData
}, {
  moduleName: 'Files',
  name: 'prepareRequestParams',
  args: ['pageNumber', 'sort'],
  mappingName: 'params',
  type: OperationType.addOperationData
}, {
  data: {
    url: '/folderViewUpdate',
    template: {
      bind: {
        params: '{params}'
      }
    },
  },
  type: OperationType.request
}, {
  data: {
    skipMassConfiguration: true
  },
  name: 'refreshFilesGrid',
  type: OperationType.action
}, {
  moduleName: 'App',
  type: OperationType.unmaskModule
}];

export const claimNotClaimedFilesWarning: Action = [{
  persistent: ['all'],
  type: OperationType.addPersistentData
}, {
  moduleName: 'Files',
  name: 'getClaimAndOpenText',
  args: ['onlineEditorParams', 'actionText'],
  mappingName: 'claimAndOpenLocales',
  type: OperationType.addOperationData
}, {
  placeholders: {
    template: {
      bind: {
        claimAndOpenText: '{claimAndOpenLocales.text}',
        claimAndOpenTitle: '{claimAndOpenLocales.title}',
      }
    }
  },
  className: 'sm warning footer-centered',
  items: [{
    btnName: 'ESCAPE',
    operations: [{
      persistent: ['all', 'onlineEditorParams', 'openFromFileClick'],
      type: OperationType.removePersistentData
    }]
  }, {
    btnName: 'notClaimedWarning.cancel',
    operations: [{
      persistent: ['all', 'onlineEditorParams', 'openFromFileClick'],
      type: OperationType.removePersistentData
    }],
    btnConfig: {
      fillMode: 'flat',
      pos: Position.end
    }
  }, {
    btnName: 'notClaimedWarning.claim',
    operations: [{
      name: 'claimNotClaimedFiles',
      type: OperationType.action
    }],
    btnConfig: {
      pos: Position.end,
      themeColor: 'primary'
    }
  }, {
    btnName: 'notClaimedWarning.claimAndOpen',
    operations: [{
      data: {
        claimAndOpen: true
      },
      persistent: ['claimAndOpen'],
      type: OperationType.addPersistentData
    }, {
      name: 'claimNotClaimedFiles',
      type: OperationType.action
    }],
    btnConfig: {
      template: {
        bind: {
          hidden: '!{onlineEditorParams}'
        }
      },
      pos: Position.end,
      themeColor: 'primary'
    }
  }],
  text: 'notClaimedWarning.text',
  title: 'notClaimedWarning.title',
  type: OperationType.warning,
  warningType: WarningType.warning
}]

export const claimNotClaimedFiles: Action = [{
  condition: '{openFromFileClick}',
  conditionOperations: [{
    data: {
      template: {
        paramsForClaim: {
          bind: {
            targetIds: '{onlineEditorParams.entityIds}',
          }
        }
      }
    },
    type: OperationType.data
  }],
  elseOperations: [{
    name: 'createRequestParams',
    args: ['all'],
    mappingName: 'paramsForClaim',
    moduleName: 'Files',
    type: OperationType.addOperationData
  }],
  type: OperationType.conditional
}, {
  persistent: ['all'],
  type: OperationType.removePersistentData
}, {
  handleErrorStatuses: [ErrorCodes.FORBIDDEN, ErrorCodes.NOT_FOUND, ErrorCodes.BAD_REQUEST, ErrorCodes.INTERNAL_SERVER_ERROR],
  data: {
    template: {
      method: 'post',
      bind: {
        url: '"/submissions/" + {selectedSubmissions[0].submissionId} + "/quickClaim"',
        params: '{paramsForClaim}'
      }
    },
  },
  mappingName: 'responseData',
  type: OperationType.request
}, {
  name: 'handleRequestException',
  type: OperationType.action
}, {
  data: {
    template: {
      bind: {
        url: '"/submissions/" + {selectedSubmissions[0].submissionId} + "/quickClaim"'
      },
      afterPingFinishAction: 'afterQuickClaimCompletion',
      method: 'post'
    }
  },
  type: OperationType.data
}, {
  name: 'pingingRequest',
  type: OperationType.action
}]

export const afterQuickClaimCompletion: Action = [{
  moduleName: 'ToastNotifications',
  name: 'createQuickClaimNotifications',
  args: ['responseData']
}, {
  name: 'refreshApp',
  type: OperationType.action
}, {
  moduleName: 'ToastNotifications',
  name: 'runStackedNotifications'
}, {
  condition: '{claimAndOpen}',
  conditionOperations: [{
    name: 'getOnlineEditorUrl',
    moduleName: 'Files',
    mappingName: 'urlsEndpoint',
    type: OperationType.addOperationData
  }, {
    name: 'getOnlineEditorAddress',
    type: OperationType.action
  }],
  type: OperationType.conditional
}, {
  persistent: ['onlineEditorParams', 'claimAndOpen', 'openFromFileClick'],
  type: OperationType.removePersistentData
}];

export const filesTabWarningTemplate: Action = [{
  condition: '_.get({onlineEditorUrl}, "response.data.errors[0].errorCode") === "REST.ERR.ACTION.FILENOTCLAIM"',
  conditionOperations: [{
    name: "claimNotClaimedFilesWarning",
    type: OperationType.action
  }],
  elseOperations: [{
    data: {
      template: {
        endpointPrefix: 'EDITOR_URLS_',
        bind: {
          responseData: '{onlineEditorUrl}',
        }
      }
    },
    name: 'handleRequestException',
    type: OperationType.action
  }, {
    persistent: ['onlineEditorParams', 'openFromFileClick'],
    type: OperationType.removePersistentData
  }],
  type: OperationType.conditional
}];

export const handleDrawerResize: Action = [{
  moduleName: 'DrawerContent',
  name: 'getSelectedTab',
  mappingName: 'selectedTab',
  type: OperationType.addOperationData
}, {
  condition: '{selectedTab} === "FILES"',
  conditionOperations: [{
    name: 'updateFilesGridHeight',
    type: OperationType.action
  }],
  type: OperationType.conditional
}]
export const folderViewUpdateFiles: Action = [{
  data: {
    url: '/folderViewUpdate',
    template: {
      bind: {
        params: '{params}'
      }
    },
  },
  type: OperationType.request
}, {
  name: 'removePersistentActionData',
  type: OperationType.action
}];

export const maxFileSelectionExceededWarning: Action = [{
  title: 'filesTabWarningTemplate.title',
  className: 'sm warning footer-centered',
  placeholders: {
    template: {
      bind: {
        message: '{message}'
      }
    }
  },
  text: 'filesTabWarningTemplate.message',
  items: [{
    btnName: 'filesTabWarningTemplate.close',
    btnConfig: {
      fillMode: 'flat',
      pos: Position.end
    },
  }],
  warningType: WarningType.warning,
  type: OperationType.warning
}];


export const unableToOpenWarning: Action = [{
  warningType: WarningType.warning,
  className: 'sm warning footer-centered',
  title: 'unableToOpenWarning.title',
  text: 'unableToOpenWarning.text',
  items: [{
    operations: [],
    btnName: 'unableToOpenWarning.close',
    btnConfig: {
      pos: Position.end,
      fillMode: 'flat'
    }
  }],
  type: OperationType.warning
}];

//used for GLT/GLR (former TSO) editor close
export const processTscClose: Action = [{
  data: {
    template: {
      method: 'get',
      bind: {
        url: '"/submissions/editor/upload/status/" + {pingParam.editorSessionId}'
      }
    },
  },
  mappingName: 'tscRequestData',
  type: OperationType.request
}, {
  data: {
    template: {
      bind: {
        responseData: '{tscRequestData}',
      }
    }
  },
  name: 'handleRequestException',
  type: OperationType.action
}, {
  data: {
    template: {
      toasterModuleId: 'ToastNotificationsViewport'
    }
  },
  type: OperationType.data
}, {
  condition: '_.get({drawerState},"detached") && {appDetachedWindow}',
  conditionOperations: [{
    data: {
      template: {
        toasterModuleId: 'ToastNotificationsDrawer'
      }
    },
    type: OperationType.data
  }],
  type: OperationType.conditional
}, {
  evaluate: true,
  moduleName: 'ToastNotifications',
  moduleId: '{toasterModuleId}',
  name: 'createTscNotification',
  args: ['tscRequestData']
}, {
  name: 'refreshApp',
  type: OperationType.action
}];

export const toggleScrollOnFilesTab: Action = [{
  moduleName: 'Files',
  name: 'toggleScroll',
  args: ['disableScroll']
}];

export const loadCommentsData: Action = [{
  data: {
    template: {
      method: 'get',
      bind: {
        url: '"/submissions/" + {submissionId} + "/comments/display/" + {targetId}',
        params: '{params}'
      }
    },
  },
  mappingName: 'commentsData',
  type: OperationType.request
}, {
  evaluate: true,
  moduleName: 'AnchorPopup',
  moduleId: '{moduleId}',
  name: 'loadCommentsData',
  args: ['commentsData']
}];

export const addComment: Action = [{
  data: {
    template: {
      method: 'post',
      bind: {
        url: "'/submissions/' + {submissionId} + '/comments/add'",
        params: '{params}'
      }
    },
  },
  mappingName: 'commentsResponse',
  type: OperationType.request
}, {
  condition: '_.get({drawerState},"detached")',
  conditionOperations: [{
    data: {
      template: {
        toasterModuleId: 'ToastNotificationsDrawer'
      }
    },
    type: OperationType.data
  }],
  type: OperationType.conditional
}, {
  evaluate: true,
  moduleName: 'ToastNotifications',
  moduleId: '{toasterModuleId} || "ToastNotificationsViewport"',
  args: ['notificationData'],
  name: 'addToNotificationStack'
}, {
  name: 'refreshFilesGrid',
  type: OperationType.action
}, {
  moduleName: 'ToastNotifications',
  name: 'runStackedNotifications'
}, {
  persistent: ['params', 'notificationData', 'submissionId'],
  type: OperationType.removePersistentData
}];

export const closeConfirmWarning: Action = [{
  data: {
    eventAdd: 'addEventListener'
  },
  type: OperationType.data
}, {
  moduleName: 'AnchorPopup',
  name: 'eventListenerForMouseDown',
  args: ['eventAdd']
}, {
  windowType: WindowType.warning,
  type: OperationType.closeWindow
}];

export const confirmClosingOfAnchorPopup: Action = [{
  items: [{
    btnName: 'ESCAPE',
    operations: [{
      name: 'closeConfirmWarning',
      type: OperationType.action
    }]
  }, {
    operations: [{
      name: 'closeConfirmWarning',
      type: OperationType.action
    }],
    btnName: 'common.cancel',
    btnConfig: {
      fillMode: 'flat',
      pos: Position.end
    }
  }, {
    operations: [{
      moduleName: 'AnchorPopup',
      name: 'closePopup'
    }],
    btnName: 'common.exit',
    btnConfig: {
      themeColor: 'error',
      pos: Position.end
    }
  }],
  className: 'sm confirm-light exit-file-comments',
  text: 'exitFileComments.text',
  title: 'exitFileComments.title',
  type: OperationType.warning
}];

export const openFileCommentsDialog: Action = [{
  data: {
    template: {
      selectedFilesTranslated: 'fileComments.selectedFiles',
      bind: {
        filesCount: '{filesCount}'
      }
    }
  },
  type: OperationType.data
}, {
  persistent: ['selectAll'],
  type: OperationType.addPersistentData
}, {
  title: 'fileComments.title',
  children: [{
    render: AddCommentsDialog,
    propArgs: ['targetIds', 'folder', 'submissionId', 'selectAll']
  }],
  className: 'sm file-comments',
  closable: true,
  items: [{
    btnName: 'ESCAPE',
    close: false,
    operations: [{
      name: 'confirmExitFileCommentsDialog',
      type: OperationType.action
    }]
  }, {
    operations: [],
    btnName: 'fileComments.selectedCounter',
    btnConfig: {
      pos: Position.start,
      args: ['selectedFilesTranslated', 'filesCount'],
      customTagType: CustomTagType.counter
    }
  }, {
    btnName: 'common.cancel',
    btnConfig: {
      fillMode: 'flat',
      pos: Position.end
    },
    close: false,
    operations: [{
      name: 'confirmExitFileCommentsDialog',
      type: OperationType.action
    }]
  }, {
    btnName: 'fileComments.save',
    close: false,
    btnConfig: {
      disabled: true,
      themeColor: 'primary',
      pos: Position.end
    },
    operations: [{
      name: 'saveCommentFromDialog',
      type: OperationType.action
    }]
  }],
  type: OperationType.dialog
}];

export const saveCommentFromDialog: Action = [{
  moduleName: 'Files',
  name: 'createRequestParams',
  args: ['selectAll'],
  mappingName: 'requestData',
  type: OperationType.addOperationData
}, {
  persistent: ['selectAll'],
  type: OperationType.removePersistentData
}, {
  moduleName: 'AddCommentsDialog',
  args: ['requestData'],
  name: 'getRequestParams',
  mappingName: 'dataForRequest',
  type: OperationType.addOperationData
}, {
  data: {
    template: {
      bind: {
        params: '{dataForRequest.params}',
        notificationData: '{dataForRequest.notificationData}',
        submissionId: '{dataForRequest.submissionId}'
      }
    },
  },
  type: OperationType.data
}, {
  persistent: ['params', 'notificationData', 'submissionId'],
  type: OperationType.addPersistentData
}, {
  name: 'addComment',
  type: OperationType.action
}, {
  name: 'closeDialog',
  type: OperationType.action
}];

export const updateFileCommentsDialog: Action = [{
  buttons: [{
    name: 'fileComments.save',
    disabled: '{disableSaveButton}'
  }],
  type: OperationType.updateDialog
}];

export const showCommentsWarning: Action = [{
  condition: '{warningDialog}',
  showCommentsNotConfigured: [{
    title: 'showCommentsNotConfigured.title',
    className: 'sm warning footer-centered',
    text: 'showCommentsNotConfigured.text',
    items: [{
      btnName: 'common.close',
      btnConfig: {
        fillMode: 'flat',
        pos: Position.end
      },
    }],
    warningType: WarningType.warning,
    type: OperationType.warning
  }],
  showNotClaimed: [{
    name: 'claimNotClaimedFilesWarning',
    type: OperationType.action
  }],
  showNotSameBatchOrPhase: [{
    title: 'showNotSameBatchOrPhase.title',
    className: 'sm warning footer-centered',
    text: 'showNotSameBatchOrPhase.text',
    items: [{
      btnName: 'common.close',
      btnConfig: {
        fillMode: 'flat',
        pos: Position.end
      },
    }],
    warningType: WarningType.warning,
    type: OperationType.warning
  }],
  type: OperationType.switch
}];

export const confirmExitFileCommentsDialog: Action = [{
  moduleName: 'AddCommentsDialog',
  name: 'getCommentText',
  mappingName: 'commentText',
  type: OperationType.addOperationData
}, {
  condition: '{commentText}',
  conditionOperations: [{
    items: [{
      btnName: 'ESCAPE',
      operations: []
    }, {
      operations: [],
      btnName: 'common.cancel',
      btnConfig: {
        fillMode: 'flat',
        pos: Position.end
      }
    }, {
      operations: [{
        name: 'closeDialog',
        type: OperationType.action
      }],
      btnName: 'common.exit',
      btnConfig: {
        themeColor: 'error',
        pos: Position.end
      }
    }],
    className: 'sm confirm-light exit-file-comments',
    text: 'exitFileComments.text',
    title: 'exitFileComments.title',
    type: OperationType.warning
  }],
  elseOperations: [{
    name: 'closeDialog',
    type: OperationType.action
  }],
  type: OperationType.conditional
}];
